import type { Specialization_ProductVariant } from '__generated__/graphql-types';
import URI from 'jsuri';

import config from 'js/app/config';
import path from 'js/lib/path';

import type { S12nProductVariant } from 'bundles/accomplishments/types';
import { getS12nAccomplishmentsUrl } from 'bundles/s12n-common/lib/s12nProductVariantUtils';

const courseCertUrl = '/account/accomplishments';
const specializationUrl = '/account/accomplishments/specialization';
const badgeUrl = '/account/accomplishments/badge';

export function getCertificateSharingLink(isSpecialization: boolean, verifyCode: string): string {
  if (isSpecialization) {
    return path.join(config.url.base, specializationUrl, 'certificate', verifyCode);
  } else {
    return path.join(config.url.base, courseCertUrl, 'certificate', verifyCode);
  }
}

export function getCourseCertificateRecordsLink(verifyCode: string, isSpecialization?: boolean): string {
  if (isSpecialization) {
    return path.join(config.url.base, specializationUrl, verifyCode);
  } else {
    return path.join(config.url.base, courseCertUrl, 'records', verifyCode);
  }
}

export function getCourseCertificateVerifyLink(verifyCode: string): string {
  return path.join(config.url.base, courseCertUrl, 'verify', verifyCode);
}

export function getSpecializationCertificateRecordsLink(
  productVariant: S12nProductVariant | Specialization_ProductVariant,
  verifyCode: string
): string {
  return path.join(config.url.base, getS12nAccomplishmentsUrl(productVariant, verifyCode));
}

export function getCertificateDownloadLink(
  userId: string,
  isSpecialization: boolean,
  verifyCode: string,
  isSpark: boolean
): string {
  if (isSpark) {
    if (isSpecialization) {
      const uri = path.join(
        config.url.base,
        '/api/legacyCertificates.v1/spark/s12nCertificate',
        verifyCode + '~' + userId,
        'pdf'
      );
      return new URI(uri).toString();
    } else {
      return path.join(config.url.base, `/api/legacyCertificates.v1/spark/verifiedCertificate/${verifyCode}/pdf`);
    }
  } else {
    return path.join(config.url.base, 'api/certificate.v1/pdf', verifyCode);
  }
}

export function getCourseLink(courseSlug: string) {
  return path.join(config.url.base, '/', 'learn', courseSlug);
}

/**
 * Builds an absolute URL for a badge page.
 * like https://www.coursera.org/account/accomplishments/badge/ABC123456789
 */
export const getBadgePageUrl = (badgeId: string) => {
  return path.join(config.url.base, '/', badgeUrl, badgeId);
};

export function getSpecializationLink(s12nSlug: string) {
  return path.join(config.url.base, '/', 'specializations', s12nSlug);
}

export const convertPathnameToSlug = (pathname: string): string => {
  const adjustedPath = pathname.replace(/^\/|\/$/g, '');
  const slug = adjustedPath.replace(/\//g, '-');
  return slug;
};

export default {
  getCertificateSharingLink,
  getCourseCertificateRecordsLink,
  getCourseCertificateVerifyLink,
  getSpecializationCertificateRecordsLink,
  getCertificateDownloadLink,
  getCourseLink,
  getSpecializationLink,
  convertPathnameToSlug,
};
